type CalcCreditsToConsumeOptions = {
  // Contract credits are stored as decimal(10,2), so rounding up here loses the
  // fractional part of a negotiated value (e.g. 126.79 became 127). Both PO
  // contract flows (create and update) opt in to keep the fraction; the booking
  // flow still takes the default ceil.
  allowFractional?: boolean;
};

export function CalcCreditsToConsume(
  creditsPrice: number,
  roomMontlyPrice: number,
  options?: CalcCreditsToConsumeOptions,
): number {
  const creditsPriceAdjusted = creditsPrice > 80 ? 80 : creditsPrice;
  const creditsToConsume = roomMontlyPrice / creditsPriceAdjusted;

  if (options?.allowFractional) {
    return Math.round(creditsToConsume * 100) / 100;
  }

  return Math.ceil(creditsToConsume);
}
